module.exports = __webpack_public_path__ + "img/logo.e88afaf9.svg";